module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-grid/time-roll-san-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-grid/time-roll-san-grid.component.css
// module chunks = main